import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

const DebugSupabase = () => {
  const [status, setStatus] = useState('Checking connection...')
  const [divisions, setDivisions] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    const testConnection = async () => {
      try {
        // Test basic connection
        const { data, error } = await supabase.from('divisions').select('count').single()
        
        if (error) {
          setError(`Connection error: ${error.message}`)
          setStatus('Connection failed')
        } else {
          setStatus('Connected successfully')
          
          // Try to get divisions
          const { data: divisionsData, error: divisionsError } = await supabase
            .from('divisions')
            .select('*')
            .order('code')
          
          if (divisionsError) {
            setError(`Divisions error: ${divisionsError.message}`)
          } else {
            setDivisions(divisionsData)
          }
        }
      } catch (err) {
        setError(`Test failed: ${err.message}`)
        setStatus('Test failed')
      }
    }

    testConnection()
  }, [])

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h3>Supabase Debug Info</h3>
      <p><strong>Status:</strong> {status}</p>
      <p><strong>URL:</strong> {import.meta.env.VITE_SUPABASE_URL}</p>
      <p><strong>Key:</strong> {import.meta.env.VITE_SUPABASE_ANON_KEY?.substring(0, 20)}...</p>
      
      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      <div style={{ marginTop: '20px' }}>
        <h4>Divisions ({divisions.length}):</h4>
        <ul>
          {divisions.map(division => (
            <li key={division.id}>
              {division.code} - {division.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default DebugSupabase
